// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

/**
 * Send login data and retrieve a new token
 *
 * @param payload
 * @returns {Promise<T>}
 */

export const getQlikReportCloud = (payload=null) => http.post('apiQlikReporting/getQlikCloudReport', payload).then(getData);
 
export const getQlikReport = (payload=null) => http.post('apiQlikReporting/getQlikReport',payload).then(getData);
export const getQlikReportLegacy = (payload=null) => http.post('apiQlikReporting/getQlikReportLegacy',payload).then(getData);
export const getQlikTennant = () => http.get('apiQlikReporting/getQlikTennant').then(getData);


export const getReports = (payload=null) =>  http.post('apiQlikReporting/getAvailReports', payload).then(getData);

export const getSheets = (payload) =>  http.post('apiQlikReporting/getAvailSheets',payload).then(getData);

export const generateReport= (payload) => http.post("apiQlikReporting/test",payload).then(getData);